var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(-4773 -1289)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    d: "M15.3,0,30.6,34.105H0Z",
    transform: "translate(4775.701 1289.948)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "alert",
    transform: "translate(4773 1289)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M22,4a1.79,1.79,0,0,1,1.591,1.008l16.2,32.211a1.982,1.982,0,0,1-.049,1.864A1.783,1.783,0,0,1,38.2,40H5.8a1.783,1.783,0,0,1-1.542-.917,1.982,1.982,0,0,1-.049-1.864l16.2-32.211A1.79,1.79,0,0,1,22,4ZM35.21,36.211,22,9.944,8.79,36.211Z",
    transform: "translate(-4 -4)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M23.8,29.368A1.849,1.849,0,0,1,22,27.474V19.895a1.8,1.8,0,1,1,3.6,0v7.579A1.849,1.849,0,0,1,23.8,29.368Z",
    transform: "translate(-5.8 -4.737)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 1.8,
    cy: 1.895,
    rx: 1.8,
    ry: 1.895,
    transform: "translate(16.2 26.526)",
    fill: "red"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.c97f81677a0cc17dbab405ddefcd3091.svg";
export { ForwardRef as ReactComponent };